import { useEffect } from 'react';
import { useAuth } from './auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Spin, Typography, Flex } from 'antd';

const { Text } = Typography;

export default function Callback() {
  const { authenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // The AuthContext handles the OAuth callback automatically
    // Once authenticated, redirect to home page
    if (authenticated) {
      navigate('/', { replace: true });
    }
  }, [authenticated, navigate]);

  return (
    <Flex
      vertical
      justify="center"
      align="center"
      gap={16}
      style={{ minHeight: '100vh' }}
      role="status"
      aria-live="polite"
    >
      <Spin size="large" />
      <Text style={{ fontSize: 16 }}>Signing you in…</Text>
    </Flex>
  );
}
